module.exports = __webpack_public_path__ + "static/fighting-infernos-before-they-start-3848dffdda2a4361e66d92665685d456.jpg";